"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareDialogDashboardHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../model");
var shareDialog_1 = require("../../shareDialog");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var locales_1 = require("../../../locales");
var useShareDialogDashboardHeader = function () {
    var dispatch = model_1.useDashboardDispatch();
    var _a = sdk_ui_kit_1.useToastMessage(), addSuccess = _a.addSuccess, addError = _a.addError;
    var shareDialogInteraction = model_1.useDashboardUserInteraction().shareDialogInteraction;
    var isShareDialogOpen = model_1.useDashboardSelector(model_1.selectIsShareDialogOpen);
    var persistedDashboard = model_1.useDashboardSelector(model_1.selectPersistedDashboard);
    var currentUser = model_1.useDashboardSelector(model_1.selectCurrentUser);
    var isWorkspaceManager = model_1.useDashboardSelector(model_1.selectCanManageWorkspace);
    var dashboardPermissions = model_1.useDashboardSelector(model_1.selectDashboardPermissions);
    var backend = sdk_ui_1.useBackendStrict();
    var workspace = sdk_ui_1.useWorkspaceStrict();
    var runChangeSharing = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.changeSharing,
        successEvent: "GDC.DASH/EVT.SHARING.CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onSuccess: function () {
            addSuccess(locales_1.messages.messagesSharingChangedSuccess);
        },
        onError: function () {
            addError(locales_1.messages.messagesSharingChangedError);
        },
    }).run;
    var closeShareDialog = react_1.useCallback(function () { return dispatch(model_1.uiActions.closeShareDialog()); }, [dispatch]);
    var onCloseShareDialog = react_1.useCallback(function () {
        closeShareDialog();
    }, [closeShareDialog]);
    var onApplyShareDialog = react_1.useCallback(function (payload) {
        closeShareDialog();
        runChangeSharing(payload);
    }, [closeShareDialog, runChangeSharing]);
    var onErrorShareDialog = react_1.useCallback(function () {
        dispatch(model_1.uiActions.closeShareDialog());
        addError(locales_1.messages.messagesSharingDialogError);
    }, [dispatch, addError]);
    return {
        backend: backend,
        workspace: workspace,
        isShareDialogOpen: isShareDialogOpen,
        persistedDashboard: persistedDashboard,
        currentUser: currentUser,
        onCloseShareDialog: onCloseShareDialog,
        onApplyShareDialog: onApplyShareDialog,
        onErrorShareDialog: onErrorShareDialog,
        onInteractionShareDialog: shareDialogInteraction,
        isLockingSupported: isWorkspaceManager,
        isCurrentUserWorkspaceManager: isWorkspaceManager,
        dashboardPermissions: dashboardPermissions,
    };
};
/**
 * @internal
 */
exports.ShareDialogDashboardHeader = function () {
    var _a = useShareDialogDashboardHeader(), backend = _a.backend, workspace = _a.workspace, isShareDialogOpen = _a.isShareDialogOpen, persistedDashboard = _a.persistedDashboard, currentUser = _a.currentUser, onCloseShareDialog = _a.onCloseShareDialog, onApplyShareDialog = _a.onApplyShareDialog, onErrorShareDialog = _a.onErrorShareDialog, onInteractionShareDialog = _a.onInteractionShareDialog, isLockingSupported = _a.isLockingSupported, isCurrentUserWorkspaceManager = _a.isCurrentUserWorkspaceManager, dashboardPermissions = _a.dashboardPermissions;
    if (!isShareDialogOpen) {
        return null;
    }
    var currentUserPermissions = {
        canEditAffectedObject: dashboardPermissions.canEditDashboard,
        canEditLockedAffectedObject: dashboardPermissions.canEditLockedDashboard,
        canShareAffectedObject: dashboardPermissions.canShareDashboard,
        canShareLockedAffectedObject: dashboardPermissions.canShareLockedDashboard,
        canViewAffectedObject: dashboardPermissions.canViewDashboard,
    };
    return (react_1.default.createElement(shareDialog_1.ShareDialog, { backend: backend, workspace: workspace, isVisible: isShareDialogOpen, currentUser: currentUser, sharedObject: persistedDashboard, onCancel: onCloseShareDialog, onApply: onApplyShareDialog, onError: onErrorShareDialog, isLockingSupported: isLockingSupported, isCurrentUserWorkspaceManager: isCurrentUserWorkspaceManager, currentUserPermissions: currentUserPermissions, onInteraction: onInteractionShareDialog }));
};
//# sourceMappingURL=ShareDialogDashboardHeader.js.map